module.exports = __webpack_public_path__ + "img/collar button diameter.846542e5.png";